import React, {  useState } from "react";
import { useNavigate } from "react-router-dom";
import { Footer } from "@components";
import { useForm, FormProvider } from "react-hook-form";
import { post, get } from "@utils/axios_api";
import { Input,Radio,Select,PhoneInput } from "@components/form";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useSignup } from '@context/SignupContext';
import { validateDuplicateId, validateDuplicateEmail } from "@utils/validation";
import {  useQuery } from '@tanstack/react-query';

const Signup = () => {  
  const navigate = useNavigate();
  const { agreedTermIds } = useSignup();


  const [showPassword, setShowPassword] = useState(false); // 패스워드 보이기
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false); // 패스워드 확인 보이기

  const today = new Date().toISOString().split("T")[0];
  const PW_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,20}$/;

  const methods = useForm({
    defaultValues: {
      memberId: "",
      memberNm: "",
      birthDt: "",
      genderCd: "",
      password: "",
      phoneNo: "",
      email: "",
      zipcode: "",
      address1: "",
      address2: "",
      // bizRegNo: "",
      departmentNm: "",
      positionNm: "",
    },
  });

  const { handleSubmit, setValue, watch } = methods;
  const values = watch();


  // const { data:companyList } = useQuery({
  //   queryKey: ["adminSearchCompanyList"],
  //   queryFn: async () => {
  //     const response = await get("/member/companyList");
  //     return response;
  //   },
  // });


  const onSubmit = async (data) => {

    const requiredOK = agreedTermIds.length && agreedTermIds.length >= 3;
    if (!requiredOK) {
      alert('필수 약관에 동의 후 다시 시도하세요.');
      return;
    }

    try {
        const response = await post('/member/insertMember', {member:data, agreedTermIds});

        alert(response.message || '회원 가입 성공');

        localStorage.removeItem('termsAccepted');
        localStorage.removeItem('agreedTermIds');
        localStorage.removeItem('verified');
        navigate('/main')
    } catch (error) {
      console.error('회원 가입 중 오류 발생:', error);
      if (error.response && error.response.data && error.response.data.message) {
        alert(error.response.data.message);
      } else {
        alert('회원 가입 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    }
  };

  const onError = (errors) => {
    alert("필수 입력란을 확인해주세요.");
  };


  const handleAddressSearch = () => {
    new window.daum.Postcode({
      oncomplete: function (data) {
        setValue("zipcode", data.zonecode, { shouldValidate: true });
        setValue("address1", data.address, { shouldValidate: true });
      },
    }).open();
  };


  return (
    <FormProvider {...methods}>
    <main id="main" className="mainpage">
      <div>
        <div className="section main-contact">
          <div className="sub-tit-bg">
            <div className="container sub-h">
              <div className="sub-tit-01">
                <img src="/img/ico-home.png" alt="home" />
                회원가입 | 정보입력
              </div>
            </div>
          </div>

          <div className="sub-container">
            <div className="sub-layout">
              <div className="sub-contact">
                <h3 className="border-bt">회원가입</h3>
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                  <ul className="member-box">
                    <li><span>1</span>약관동의</li>
                    {/* <li><span>2</span>본인인증</li> */}
                    {/* <li><span className="on">3</span>정보입력</li> */}
                    <li><span className="on">2</span>정보입력</li>
                  </ul>
                  <div className="lineTop_tb01">
                    <table className="lineTop_tb2 table-td-left point">
                    <colgroup>
                      <col style={{ width: '150px' }} />
                      <col />
                      <col style={{ width: '150px' }} />
                      <col />
                    </colgroup>
                    <thead></thead>
                      <tbody>
                        <tr>
                          <th>
                            아이디 <b>*</b>
                          </th>
                          <td>
                            <div className="fom-item" >
                              <Input
                                name="memberId"
                                placeholder="아이디를 입력하세요"
                                className="inp-sel-sub"
                                style={{width:"250px"}}
                                maxLength={30}
                                rules={{ 
                                    required:"아이디를 입력하세요.",
                                    pattern: {
                                        value: /^[A-Za-z0-9]+$/,
                                        message: "영문과 숫자만 입력 가능합니다."
                                      },
                                    validate: validateDuplicateId
                                    // validate: (value) => {
                                    //   return validateDuplicateId(value);
                                    // },
                                }}
                              />
                            </div>
                          </td>
                          <th>성별 <b>*</b></th>
                          <td>
                            <div className="fom-item" style={{display:"flex", gap:"10px"}}>
                              <Radio label="남자" name="genderCd" value="M" rules={{ required:true }}/> 
                              <Radio label="여자" name="genderCd" value="F" rules={{ required:true }} className="ml10" />
                            </div>
                          </td>

                        </tr>
                        <tr>

                        </tr>
                        <tr>
                          <th>
                            비밀번호 <b>*</b>
                          </th>
                          <td>
                          <div className="password-input-wrapper" >
                            <Input
                              name="password"
                              type={showPassword ? "text" : "password"}
                              maxLength={20}
                              placeholder="영문/숫자/특수문자 조합 6~20자리"
                              className="inp-sel-sub"
                              rules={{
                                required: "비밀번호를 입력하세요.",
                                pattern: { value: PW_REGEX, message: "영문·숫자·특수문자 포함 6~20자리" }
                              }}
                            />
                            <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                          </td>
                          <th>
                            비밀번호 확인 <b>*</b>
                          </th>
                          <td>
                            <div className="password-input-wrapper" >
                              <Input
                                name="passwordConfirm"
                                type={showPasswordConfirm ? "text" : "password"}
                                placeholder="비밀번호를 다시 입력하세요"
                                className="inp-sel-sub"
                                rules={{
                                  required: "비밀번호를 한 번 더 입력하세요.",
                                  validate: (v) => !values.password || v === values.password || "비밀번호가 일치하지 않습니다."
                                }}
                              />
                              <span className="password-toggle-icon" onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}>
                                {showPasswordConfirm ? <FaEyeSlash /> : <FaEye />}
                              </span>
                            </div>
                          </td>
                        </tr>
                        <tr>

                        </tr>
                        <tr>
                          <th>이름 <b>*</b></th>
                          <td>
                            <div >
                              <Input
                                name="memberNm"
                                // disabled
                                className="inp-sel-sub"
                                rules={{ required:true }}
                                style={{width:"250px"}}
                                
                              />
                            </div>
                          </td>
                          <th>생년월일 <b>*</b></th>
                          <td>
                          <Input
                            type="date"
                            name="birthDt"
                            className="inp-sel-sub"
                            max={today}
                            rules={{ required:true }}
                            style={{width:"250px"}}
                          />
                          </td>
                        </tr>
                        <tr>
                          <th>연락처 <b>*</b></th>
                          <td >
                          <div >
                          <PhoneInput
                            name="phoneNo"
                            placeholder="연락처를 입력하세요"
                            className="inp-sel-sub"
                            rules={{ required:true }}
                            style={{width:"250px"}}
                          />
                          </div>
                          </td>
                          <th>
                            이메일 <b>*</b>
                          </th>
                          <td>
                            <div className="fom-item" >
                              <Input
                                name="email"
                                placeholder="이메일을 입력하세요"
                                className="inp-sel-sub"
                                style={{width:"250px"}}
                                maxLength={30}
                                rules={{
                                    required: "이메일을 입력하세요.",
                                    pattern: {
                                        value: /^[A-Za-z0-9@.]+$/,
                                        message: "이메일 형태로 작성해주세요"
                                      },
                                    validate: validateDuplicateEmail
                                    // validate: (value) => {
                                    //     return validateDuplicateEmail(value);
                                    //   },
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>소속</th>
                          <td>
                            <div className="fom-item">
                              <Input
                                name="departmentNm"
                                className="inp-sel-sub"
                                maxLength={15}
                                style={{width:"250px"}}
                              />
                            </div>
                          </td>
                          <th>직책</th>
                          <td>
                            <div className="fom-item">
                              <Input
                                name="positionNm"
                                className="inp-sel-sub"
                                maxLength={15}
                                style={{width:"250px"}}
                              />
                            </div>
                          </td>
                        </tr>
                        {/* <tr >
                        <th>업체조회 <b>*</b></th>
                          <td colSpan={3}>
                          <Select
                            name="bizRegNo"
                            options={companyList?.result ?? []}
                            defaultOption="업체를 선택하세요"
                            className="inp-sel-sub"
                            valueKey="bizRegNo" // key 값 (value)
                            labelKey="companyNm" // 텍스트 보이는 이름
                            style={{width:"30%"}}
                          />
                          </td>
                          </tr> */}
                          <tr>
                          <th>주소</th>
                          <td  colSpan={3} >
                            <div className="fom-item mb5">
                              <Input
                                name="zipcode"
                                placeholder="우편번호"
                                readOnly
                                className="inp-sel-sub mr5"
                                style={{width:"370px"}}
                              />
                              <button
                                type="button"
                                className="btn btn-blue2 ml10"
                                onClick={handleAddressSearch}
                                
                              >
                                주소검색
                              </button>
                            </div>
                              <Input
                                name="address1"
                                placeholder="주소"
                                readOnly
                                className="inp-sel-sub mr5 mt10"
                                maxLength={30}
                                style={{width:"470px"}}
                              />
                              <Input
                                name="address2"
                                placeholder="상세주소를 입력하세요"
                                className="inp-sel-sub mt10"
                                maxLength={30}
                                style={{width:"470px"}}
                              />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="text-cent">
                    <button
                      type="submit"
                      className="btn btn-blue mt30 btn-big"
                      id="modalOpenButton"
                    >
                      회원가입
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </main>
    </FormProvider>

  );
};

export default Signup;
